const formatCurrency = (currency_cents) => {
  return '$' + (currency_cents / 100.0).toFixed(2)
}

const formatDate = (datestr) => {
  const d = new Date(datestr)
  return (d.getMonth()+1) + "-" + 
    String(d.getDate()).padStart(2,'0') + "-" + 
    String(d.getFullYear()).substring(2)
} 

const truncate = (str, len) => {
  if (str.length <= len )
    return str
  
  return str.substring(0, len) + '...'
}

export {
  formatCurrency,
  formatDate,
  truncate,
}

export default {
  formatCurrency,
  formatDate,
  truncate,
}